
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 0C6.514 0 4.5 1.902 4.5 4.25S6.514 8.5 9 8.5s4.5-1.902 4.5-4.25S11.486 0 9 0zm2.25 4.25c0-1.169-1.012-2.125-2.25-2.125-1.237 0-2.25.956-2.25 2.125S7.763 6.375 9 6.375c1.238 0 2.25-.956 2.25-2.125zm4.5 9.563c-.225-.755-3.713-2.126-6.75-2.126s-6.525 1.371-6.75 2.136v1.052h13.5v-1.063zm-15.75 0c0-2.827 5.996-4.25 9-4.25 3.004 0 9 1.423 9 4.25V17H0v-3.188z","fill":"#888"}})])
          )
        }
      }
    